import { assertNever } from '@freelancer/utils';
import {
  HandoverApi,
  HandoverUserRoleApi,
} from 'api-typings/contests/contests';
import { _transformContestEntry } from '../contest-entries';
import { _transformContestHandovers } from '../contest-handovers';
import { _transformContest } from '../contests';
import { _transformBaseUser } from '../users';
import {
  ManageContestHandoverStatus,
  ManageViewContestHandover,
  ManageViewContestHandoverContext,
} from './manage-view-contest-handovers.model';

export function transformManageViewContestHandover(
  handover: HandoverApi,
  { role, users }: ManageViewContestHandoverContext,
): ManageViewContestHandover {
  if (
    !users ||
    !handover.contest_id ||
    !handover.entry_id ||
    !handover.buyer_id ||
    !handover.seller_id
  ) {
    throw new Error('Required values not found.');
  }

  const buyer = users[handover.buyer_id];
  const seller = users[handover.seller_id];

  switch (role) {
    case HandoverUserRoleApi.BUYER:
      if (!seller) {
        throw new Error('Seller is missing in the backend response');
      }

      return {
        role,
        ..._transformContestHandovers(handover),
        sellerDetails: _transformBaseUser(seller),
        handoverStatus: getHandoverStatus(handover),
      };
    case HandoverUserRoleApi.SELLER:
      if (!buyer) {
        throw new Error('Buyer is missing in the backend response');
      }

      return {
        role,
        ..._transformContestHandovers(handover),
        buyerDetails: _transformBaseUser(buyer),
        handoverStatus: getHandoverStatus(handover),
      };
    default:
      return assertNever(role);
  }
}

function getHandoverStatus(handover: HandoverApi) {
  if (!handover.buyer_confirmed && handover.seller_confirmed) {
    return ManageContestHandoverStatus.FOR_REVIEW;
  }
  return ManageContestHandoverStatus.IN_PROGRESS;
}
